import { FileDto } from './file.dto'
import { MallDto } from './mall.dto'
import { TenantDto } from './tenant.dto'
import { GovernTenantDto } from './governance-admin/tenant.dto'

export class ProfileDto {
  id: string
  fullName: string
  email?: string
  phoneNumber: string
  photo: FileDto
  roleNames: string[]
  mall?: MallDto
  mallId?: string
  tenant?: TenantDto
  offlineTenant?: GovernTenantDto
  reportRecipientEmail: string
  offlineTenantId?: string
  /** When true, Food ordering (F&B) features are enabled for this user/tenant. */
  fnbOrderingEnabled?: boolean

  static create() {
    return new ProfileDto()
  }
}

export class UpdateProfileDto {
  public fullName: string
  public email: string
  public phoneNumber: string
  reportRecipientEmail: string

  static create(data: UpdateProfileDto) {
    return Object.assign(new UpdateProfileDto(), data)
  }
}
